import React from 'react'
import noop from 'lib/noop'
import classNames from 'classnames'

import { Button } from 'components'

import styles from './ActionContactCompany.module.scss'

const ActionContactCompany = ({
  show = true,
  preview = false,
  showVisit,
  scheduleAction = noop,
  contactUsAction = noop,
  showContactUs,
  fullContactButton,
  callToActionLabel,
  contactButtonLabel,
  activeContactUs = false,
  idButton = '',
}) => {
  const disableScheduleVisit =
    callToActionLabel === 'Vendido' || callToActionLabel === 'Encerrado'
  const disableContactButtonLabel = activeContactUs || disableScheduleVisit

  return (
    show && (
      <div className={styles.horizontalContainer}>
        <Button
          id={idButton}
          showButton={showContactUs}
          name="possibleFixedButton"
          className={classNames(
            { [styles.largeButton]: fullContactButton },
            { [styles.halfButton]: !fullContactButton }
          )}
          disabled={disableContactButtonLabel}
          type="filled"
          onClick={contactUsAction}
          fontSize="medium"
          backgroundColor="secondColor"
        >
          {contactButtonLabel}
        </Button>

        {preview}

        <Button
          showButton={showVisit}
          name="possibleFixedButton"
          className={classNames(
            { [styles.largeButton]: !showContactUs },
            { [styles.halfButton]: showContactUs }
          )}
          type="filled"
          onClick={scheduleAction}
          fontSize="medium"
          disabled={disableScheduleVisit}
          backgroundColor="secondColor"
        >
          Agendar visita
        </Button>
      </div>
    )
  )
}

export default React.memo(ActionContactCompany)
